import { Navigate, useSearchParams } from "react-router-dom";
import { useDeploymentMode } from "../../hooks/useDeploymentMode";
import { defaultSuperAdminSection, findSuperAdminSection } from "./sections";

/** `/super-admin` and `/super-admin?tab=` → `/super-admin/<section>`. */
export default function SuperAdminIndexRedirect() {
  const { onPrem } = useDeploymentMode();
  const [params] = useSearchParams();
  const tab = params.get("tab");
  const section = findSuperAdminSection(tab || undefined);
  const target =
    section && !(section.saasOnly && onPrem)
      ? section.key
      : defaultSuperAdminSection(onPrem);
  return <Navigate to={`/super-admin/${target}`} replace />;
}
